import React, { useEffect } from "react";
import { useState } from "react";
import checkboxDisable from "../../assets/svgs/CheckBoxDisable.svg";
import checkboxEnable from "../../assets/svgs/CheckBoxEnable.svg";
import CheckDeviceService from "../../Auth/CheckDeviceService";
import "./Modal.css";
import style from "./MvnoModal.module.css";
const MvnoModal = ({ SelectData }) => {
  const [select, setSelect] = useState();
  const [thirdParty, setThirdParty] = useState(false);
  return (
    <div className={style["modal-wrap"]}>
      <div className={style["modal"]}>
        <div className={style["title"]}>
          <p>알뜰폰 통신사를 선택해주세요.</p>
        </div>
        <div className={style["select-btn-box"]}>
          <div className={style["select-btn-margin-box"]}>
            <button
              onClick={() => {
                setSelect(5);
              }}
              className={`${style["select-btn"]} ${
                select === 5 ? style["select"] : style["not-select"]
              }`}
            >
              알뜰폰 SKT
            </button>
          </div>
          <div className={style["select-btn-margin-box"]}>
            <button
              onClick={() => {
                setSelect(6);
              }}
              className={`${style["select-btn"]} ${
                select === 6 ? style["select"] : style["not-select"]
              }`}
            >
              알뜰폰 KT
            </button>
          </div>
          <div className={style["select-btn-margin-box"]}>
            <button
              onClick={() => {
                setSelect(7);
              }}
              className={`${style["select-btn"]} ${
                select === 7 ? style["select"] : style["not-select"]
              }`}
            >
              알뜰폰 LGU+
            </button>
          </div>
        </div>
        <div className={style["checkBtn"]}>
          <img
            onClick={() => {
              setThirdParty(!thirdParty);
            }}
            src={thirdParty ? checkboxEnable : checkboxDisable}
          ></img>
          <div>
            <p
              onClick={() => {
                setThirdParty(!thirdParty);
              }}
            >
              [필수] 개인정보 제 3자 제공 동의
            </p>
            <p
              style={{
                color: "#007bff",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                // React Native 웹뷰에서의 외부 링크 처리
                const isReactNativeWebView =
                  window.ReactNativeWebView ||
                  window.navigator.userAgent.includes("ReactNativeWebView") ||
                  window.navigator.userAgent.includes("wv") ||
                  (window.navigator.userAgent.includes("Android") &&
                    window.navigator.userAgent.includes("wv"));

                if (isReactNativeWebView) {
                  // React Native 웹뷰에서 네이티브로 메시지 전송
                  if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify({
                        type: "OPEN_BROWSER",
                        payload: {
                          url: "https://cert.vno.co.kr/app/agree/agree_m_05.jsp",
                        },
                      })
                    );
                  }
                } else if (window.nativeApi && window.NativeApiMethod) {
                  // 기존 네이티브 앱에서 외부 링크 처리
                  window.nativeApi.execute(
                    window.NativeApiMethod.OPEN_WEB_VIEW,
                    {
                      url: "https://cert.vno.co.kr/app/agree/agree_m_05.jsp",
                    },
                    ""
                  );
                } else {
                  // 일반 브라우저에서는 새 창으로 열기
                  window.open(
                    "https://cert.vno.co.kr/app/agree/agree_m_05.jsp",
                    "_blank"
                  );
                }
              }}
            >
              보기
            </p>
          </div>
        </div>
        <div>
          <button
            disabled={!thirdParty}
            onClick={() => {
              SelectData(select);
            }}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default MvnoModal;
